import { render, staticRenderFns } from "./ObjectGridAdvanced.vue?vue&type=template&id=1fd050bb&scoped=true"
import script from "./ObjectGridAdvanced.vue?vue&type=script&lang=js"
export * from "./ObjectGridAdvanced.vue?vue&type=script&lang=js"
import style0 from "./ObjectGridAdvanced.vue?vue&type=style&index=0&id=1fd050bb&prod&scoped=true&lang=scss"
import style1 from "./ObjectGridAdvanced.vue?vue&type=style&index=1&id=1fd050bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd050bb",
  null
  
)

export default component.exports